export default __webpack_public_path__ + "f562e48913d5b05023bc2d75c97ee48e.png";